<div class="flex flex-col gap-6">
    <div class="flex flex-col gap-1">
        <div class="flex items-center gap-3">
            <p-progress-spinner *ngIf="loading()" strokeWidth="5" [style]="{ width: '25px', height: '25px' }" />
        </div>
        <span class="font-normal text-[14px] leading-[20px] text-[#475467]">Total {{ totalSales() }}</span>
    </div>
    <p-chart type="doughnut" height="250" [data]="chartData()" [options]="chartOptions"></p-chart>
</div>
